import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as ClientTypes from "../DataTypes/clientTypes";

export const common = (
    state: StoreTypes.ICommon,
    action: ActionGenerics.IAction<ActionTypes.Actions>,
    initialSettings: StoreTypes.IInitialSettings
): StoreTypes.ICommon => {
    switch (action.type) {
        case ActionTypes.Actions.MoveNext: {
            let stepsNumber = 1;
            const isBeforeLogin = state.currentStep === StoreTypes.Step.Login - 1;
            if (isBeforeLogin && state.isUserLoggedIn) {
                //skip log in page if user is logged in
                stepsNumber = 2;
            }

            const isBeforeService = state.currentStep === StoreTypes.Step.Service - 1;
            if (isBeforeService && initialSettings.type == StoreTypes.BookingType.Class) {
                stepsNumber = 2;
            }

            return { ...state, currentStep: state.currentStep + stepsNumber };
        }

        case ActionTypes.Actions.MoveBack: {
            let stepsNumber = 1;
            const isBehindLogin = state.currentStep === StoreTypes.Step.Login + 1;
            if (isBehindLogin) {
                stepsNumber = 2;
            }

            const isBehindService = state.currentStep === StoreTypes.Step.Service + 1;
            if (isBehindService && initialSettings.type == StoreTypes.BookingType.Class) {
                stepsNumber = 2;
            }

            return { ...state, currentStep: state.currentStep - stepsNumber };
        }

        case ActionTypes.Actions.SetPageLoading: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isPageLoading: data.parameter };
        }

        case ActionTypes.Actions.RequestCancel: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, cancelRequested: data.parameter };
        }

        case ActionTypes.Actions.SetStep: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, StoreTypes.Step>;
            const step = data.parameter === StoreTypes.Step.Group ? StoreTypes.Step.When : data.parameter;
            return { ...state, currentStep: step };
        }

        case ActionTypes.Actions.UpdateIsBusy: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isBusy: data.parameter };
        }

        case ActionTypes.Actions.UpdateIsUserLoggedIn: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isUserLoggedIn: data.parameter };
        }

        case ActionTypes.Actions.UpdateLoggedInClient: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, number>;

            return { ...state, loggedInClientId: data.parameter };
        }

        case ActionTypes.Actions.UpdateBookedAppointment: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, any>;

            return { ...state, bookedAppointment: data.parameter };
        }

        case ActionTypes.Actions.UpdateClients: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, ClientTypes.IClient[]>;

            return { ...state, clients: data.parameter };
        }

        default:
            return state;
    }
};
